(function() {
  'use strict';
  
  // Check if feature is enabled
  if (!document.body.classList.contains('features--button-arrow')) {
    return;
  }
  
  // Arrow SVG - using the provided design
  const ARROW_SVG = `
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 12H20M20 12L14 6M20 12L14 18" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;
  
  /**
   * Initialize arrow animation on a button
   * @param {HTMLElement} button - The button element
   */
  function initButtonArrow(button) {
    // Skip if already initialized
    if (button.querySelector('.button__content')) {
      return;
    }
    
    // Skip buttons without text content
    const buttonText = button.textContent.trim();
    if (!buttonText) {
      return;
    }
    
    // Get all child nodes
    const childNodes = Array.from(button.childNodes);
    
    // Separate icons/SVGs from text
    const icons = [];
    const textNodes = [];
    
    childNodes.forEach(node => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        // Check if it's an icon (svg, img, or element with 'icon' class)
        if (node.tagName === 'SVG' || 
            node.tagName === 'IMG' || 
            node.classList.contains('icon')) {
          icons.push(node);
        } else {
          textNodes.push(node);
        }
      } else if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        textNodes.push(node);
      }
    });
    
    // Get the button text (excluding icons)
    let extractedText = '';
    textNodes.forEach(node => {
      if (node.nodeType === Node.TEXT_NODE) {
        extractedText += node.textContent;
      } else {
        extractedText += node.textContent || node.innerText || '';
      }
    });
    
    extractedText = extractedText.trim();
    
    // Skip if no text found
    if (!extractedText) {
      return;
    }
    
    // Clear button content
    button.innerHTML = '';
    
    // Re-add existing icons first (if any) - these stay outside the content wrapper
    icons.forEach(icon => {
      button.appendChild(icon);
    });
    
    // Create content wrapper
    const contentWrapper = document.createElement('span');
    contentWrapper.className = 'button__content';
    
    // Create text span
    const textSpan = document.createElement('span');
    textSpan.className = 'button__text';
    textSpan.textContent = extractedText;
    
    // Create arrow span
    const arrowSpan = document.createElement('span');
    arrowSpan.className = 'button__arrow';
    arrowSpan.innerHTML = ARROW_SVG;
    arrowSpan.setAttribute('aria-hidden', 'true'); // Hide from screen readers
    
    // Assemble
    contentWrapper.appendChild(textSpan);
    contentWrapper.appendChild(arrowSpan);
    button.appendChild(contentWrapper);
  }
  
  /**
   * Initialize all buttons on the page
   */
  function initAllButtons() {
    // Select all buttons (exclude Shopify payment buttons and specific buttons to skip)
    const buttons = document.querySelectorAll('.button:not(.shopify-payment-button__button):not(.button--skip-arrow)');
    
    buttons.forEach(button => {
      try {
        initButtonArrow(button);
      } catch (error) {
        console.warn('Button arrow animation error:', error, button);
      }
    });
  }
  
  /**
   * Watch for dynamically added buttons
   */
  function observeNewButtons() {
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is a button
            if (node.classList && node.classList.contains('button')) {
              initButtonArrow(node);
            }
            
            // Check for buttons within the added node
            const buttons = node.querySelectorAll && node.querySelectorAll('.button:not(.shopify-payment-button__button):not(.button--skip-arrow)');
            if (buttons) {
              buttons.forEach(initButtonArrow);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  /**
   * Initialize on DOM ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        initAllButtons();
        observeNewButtons();
      });
    } else {
      // DOM is already loaded
      initAllButtons();
      observeNewButtons();
    }
  }
  
  // Start initialization
  init();
  
})();